import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../store'
import { CurrentSubView } from '../models/enums'

const useShowEmergency = (): boolean => {
  const lastActivity = useSelector((state: RootState) => state.activityReducer.lastActivity)
  const currentSubView = useSelector((state: RootState) => state.utilsReducer.currentSubView)

  const [result, setResult] = useState<boolean>(false)

  useEffect(() => {
    if (lastActivity?.type === 'event' && lastActivity.name === 'Hospitality.ShowEmergency') {
      setResult(currentSubView === CurrentSubView.map ? false : true)
    } else {
      setResult(false)
    }
  }, [lastActivity, currentSubView])

  return result
}

export default useShowEmergency
